import { push } from "connected-react-router";

import {
  getTemplateInfo,
  deleteTemplate,
  changeTemplateVisibility,
} from '../../request';

import { checkAndRenewTokens, checkTokenError } from "./auth";
import { showErrorMessage, showSuccessMessage, closeDeleteTemplateModal } from "./ui";

//Загрузка информации о шаблоне визитки
export const TEMPLATE_INFO_LOADING_START = "Template info loading start";
export const TEMPLATE_INFO_LOADED_SUCCESSFULLY = "Template info loaded successfully";
export const TEMPLATE_INFO_LOADING_FAILED = "Failure during template info load";

//Изменение видимости шаблона визитки
export const TEMPLATE_VISIBILITY_CHANGE_START = "Template visibility change start";
export const TEMPLATE_VISIBILITY_CHANGED_SUCCESSFULLY = "Template visibility changed successfully";
export const TEMPLATE_VISIBILITY_CHANGE_FAILED = "Failure during template visibility change";

//Удаление шаблона
export const TEMPLATE_DELETION_START = "Template deletion start";
export const TEMPLATE_DELETED_SUCCESSFULLY = "Template deleted successfully";
export const TEMPLATE_DELETION_FAILED = "Failure during template deletion";

const startLoading = () => ({
  type: TEMPLATE_INFO_LOADING_START 
});

const loadSuccess = template => ({
  type: TEMPLATE_INFO_LOADED_SUCCESSFULLY,
  payload: {
    template: template || {}
  }
});

const loadFailure = () => ({
  type: TEMPLATE_INFO_LOADING_FAILED,
});

//ЗАГРУЗКА ИНФОРМАЦИИ О ШАБЛОНЕ ВИЗИТКИ
export const getTemplateInfoAsync = templateId => { 
  return async (dispatch) => {
    dispatch(startLoading());
    await dispatch(checkAndRenewTokens());
    let template;
    const accessToken = localStorage.getItem("accessToken");
    try {
      template = await getTemplateInfo(accessToken, templateId);
    } catch (err) {
      dispatch(checkTokenError(err));
      dispatch(showErrorMessage("Ошибка при загрузке шаблона!"));
      return dispatch(loadFailure());
    }
    return dispatch(loadSuccess(template));
  };
};



//ИЗМЕНЕНИЕ ВИДИМОСТИ ШАБЛОНА ВИЗИТКИ
const startVisibilityChange = () => ({
  type: TEMPLATE_VISIBILITY_CHANGE_START
});

const visibilityChangeSuccess = status => ({
  type: TEMPLATE_VISIBILITY_CHANGED_SUCCESSFULLY,
  payload: { status }
});

const visibilityChangeFailure = () => ({
  type: TEMPLATE_VISIBILITY_CHANGE_FAILED,
});

export const changeTemplateVisibilityAsync = (is_enabled, templateId) => { 
  return async (dispatch) => {
    dispatch(startVisibilityChange());
    await dispatch(checkAndRenewTokens());
    const data = { is_enabled };
    try {
      const accessToken = localStorage.getItem("accessToken");
      await changeTemplateVisibility(accessToken, data, templateId);
    } catch (err) {
      dispatch(checkTokenError(err));
      dispatch(showErrorMessage("Ошибка при изменении видимости шаблона!"));
      return dispatch(visibilityChangeFailure());
    }
    let msgText = '';
    //is_enabled = не скрывать, !is_enabled = скрывать
    if (is_enabled) msgText = 'Шаблон доступен пользователям';
    else msgText = 'Шаблон скрыт от пользователей';
    dispatch(showSuccessMessage(msgText));
    return dispatch(visibilityChangeSuccess(is_enabled));
  };
};

//УДАЛЕНИЕ ШАБЛОНА
const startDeletion = () => ({
  type: TEMPLATE_DELETION_START
});

const deletionSuccess = () => ({
  type: TEMPLATE_DELETED_SUCCESSFULLY,
});

const deletionFailure = () => ({
  type: TEMPLATE_DELETION_FAILED,
});

export const deleteTemplateAsync = templateId => { 
  return async (dispatch, getState) => {
    dispatch(startDeletion());
    await dispatch(checkAndRenewTokens());
    //Получим название шаблона
    const currentState = getState();
    const templateName = currentState.templateInfo.template.name;
    try {
      const accessToken = localStorage.getItem("accessToken");
      await deleteTemplate(accessToken, templateId);
    } catch (err) {
      dispatch(checkTokenError(err));
      dispatch(showErrorMessage("Ошибка при удалении шаблона!"));
      return dispatch(deletionFailure());
    }
    dispatch(push('/templates'));
    dispatch(closeDeleteTemplateModal());
    const msgText = `Шаблон ${templateName} удален`;
    dispatch(showSuccessMessage(msgText));
    return dispatch(deletionSuccess());
  };
};
